module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921042649_T.cc41719f.jpg";